export type ResWrapper<TData> = {
    status: ResStatus
    errorMsg?: string
    data?: TData
}

// can add things like token refresh required etc..
export enum ResStatus {
    OK = 'OK',
    ERROR = 'ERROR',
}
